/* eslint indent: 0 */
import './global.add_media_modal.less';

import React from 'react';
import ReactDOM from 'react-dom';

import isEmpty from 'lodash/isEmpty';
import without from 'lodash/without';
import intersection from 'lodash/intersection';

// Enable modals

import 'bootstrap-modal/css/bootstrap-modal.css';
import 'bootstrap/bootstrap.js';
import 'bootstrap-modal/js/bootstrap-modal.js';
import 'bootstrap-modal/js/bootstrap-modalmanager.js';

import Backbone from 'backbone';

import addMediaModalTemplate from './global.add_media_modal.tpl';

import AddYoutubeModal from './global.add_youtube_modal.js';
import EmbeddedRecorder from 'zoomforth_embedded_recorder/embedded_recorder.js';

import {
  FileZipIcon,
  PresentationIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import {
  uploadFileWithLegacyUploaderInterface
} from 'zoomforth_tools/legacy_uploader_interface.js';

import ConfirmCreatePresentationModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_create_presentation_modal.jsx';

import ConfirmCreateHtmlPackageModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_create_html_package_modal.jsx';
  
const AddMediaModal = Backbone.View.extend({
    // the add media view should not have any direct effects on 
    // its calling context during the course of its lifespan
    
    // it resolves its deferred with either assets that have been directly selected,
    // or another object (uploader, recorder, etc.) that can be managed
    // to the desired effect
    
    className: 'add-media-modal modal hide',

    events: {
      'click .action-close-modal' : 'hide',
      'click .action-add-recording': 'addRecording',
      'click .action-add-youtube': 'addFromYoutube',
      'click .action-add-presentation': 'addPresentation',
      'click .action-add-html-package': 'addHtmlPackage',
      'click .action-upload-file': 'uploadFileClicked',
      'hidden': 'hidden'
    },
    
    validInputTypes: [
      'youtube',
      'upload',
      'recording',
      'presentation',
      'html_package'
    ],
    
    enabledInputs: [
      'youtube',
      'upload',
      'library',
      'presentation',
      'html_package'
    ],
    
    //this should also be all asset types, by default
    enabledTypes: [
      'youtube',
      'pdf',
      'ppt',
      'html_package',
      'video',
      'photo',
      'other'
    ],
    
    initialize : function(options) {
      var me = this;

      options = (options || {});
      
      me.lensContentCollection = options.lensContentCollection;

      me.multiple = options.multiple !== false;

      if (options.headerText) {
        me.headerText = options.headerText;
      } else {
        me.headerText = 'What would you like to do?';
      }
      
      if (options.enabledInputs){
        // whitelist enabledInputs based off of validInputTypes
        me.enabledInputs = intersection(options.enabledInputs, me.validInputTypes);
      }
      
      if (options.enabledTypes){
        // whitelist enabledTypes based off of default enabledTypes
        me.enabledTypes =  intersection(options.enabledTypes, me.enabledTypes);
      }
      
      if (options.recordingStorageContext) {
        me.recordingStorageContext = options.recordingStorageContext;
      }
      
      me.deferred = $.Deferred();
      // resolves as (typeName, result)
      // examples are 'assets', [list of assets]
      //              'upload', uploadView
      //              'recording', recording
      
      me.uploader = options.uploader;

    },
    
    render: function() {
      this.$el.html(addMediaModalTemplate({ headerText: this.headerText, enabledInputs: this.enabledInputs }));
      this.$el.removeClass('size1 size2 size3 size4 size5 size6 size7').addClass(this.getModalSizeClass());

      ReactDOM.render(
        <PresentationIcon className="add-presentation" />,
        this.$el.find('.add-presentation-icon').get(0)
      );

      ReactDOM.render(
        <FileZipIcon className="add-html-package" />,
        this.$el.find('.add-html-package-icon').get(0)
      );

      return this;
    },
    
    // Return the 'size class' of the modal which in this context means
    // the number of media type boxes which will appear. The modal is styled
    // differently depending on this class.
    //
    getModalSizeClass: function(){
      // Because internal_links and external_links are currently handled
      // by the same UX element we account for that here (sorta lame)
      // WILCOX TODO: Move external and internal linking into seperate modals
      var shortenedInputs = without(this.enabledInputs, 'internal_link', 'external_link');
      var trueLen = this.enabledInputs.length;
      var reportLen;
      if (trueLen === shortenedInputs.length) {
        reportLen = trueLen;
      } else {
        reportLen = shortenedInputs.length + 1;
      }
      return 'size' + reportLen;
    },


    addFromYoutube: function(){
      var me = this;
      var youtubeUploader = new AddYoutubeModal({});
      youtubeUploader.show().done(function(asset){
        me.resolveSelection('assets', [asset]);
      });
    },


    addHtmlPackage: function(){
      ReactDOM.render(
        <ConfirmCreateHtmlPackageModal
          show={true}
          closeOnOuterClick={true}
          modalStyle={{
            zIndex: 10000
          }}
          shouldShowMediaLibrarySelectionOption={false}
          onRequestClose={this.handleHideHtmlPackageWarningModal}
          onUploadClick={() => {
            this.handleHideHtmlPackageWarningModal();
            this.uploadFileClicked({
              multiple: false,
              accept: ['.zip'],
              forceAssetType: 'html_package'
            });
          }}
        />,
        document.querySelector('.confirm-create-html-package-modal-container')
      );
    },
    
    addPresentation: function(){
      ReactDOM.render(
        <ConfirmCreatePresentationModal
          show={true}
          closeOnOuterClick={true}
          modalStyle={{
            zIndex: 10000
          }}
          shouldShowMediaLibrarySelectionOption={false}
          onRequestClose={this.handleHidePresentationWarningModal}
          onUploadClick={() => {
            this.handleHidePresentationWarningModal();
            this.uploadFileClicked({
              multiple: false,
              accept: ['.pdf'],
              forceAssetType: 'ppt'
            });
          }}
        />,
        document.querySelector('.confirm-create-presentation-modal-container')
      );
    },

    handleHidePresentationWarningModal: function() {
      ReactDOM.unmountComponentAtNode(
        document.querySelector('.confirm-create-presentation-modal-container')
      );
    },

    handleHideHtmlPackageWarningModal: function() {
      ReactDOM.unmountComponentAtNode(
        document.querySelector('.confirm-create-html-package-modal-container')
      );
    },
    
    addRecording: function(){
      var me = this;
      var recorder = EmbeddedRecorder.create({fullWindow: true});
      recorder.once('ready-to-save-video', function(videoBlob) {
        uploadFileWithLegacyUploaderInterface(videoBlob, me.uploader);
        me.resolveSelection('upload', me.uploader);
        recorder.remove();
      });      
    },
    
    kill: function(){
      $('.tipsy').remove();
      if(this.deferred.state() == 'pending'){
        this.deferred.reject();
      }

      this.remove();

      ReactDOM.unmountComponentAtNode(
        this.$el.find('.add-presentation-icon').get(0)
      );

      ReactDOM.unmountComponentAtNode(
        this.$el.find('.add-html-package-icon').get(0)
      );
    },
    
    hidden : function(){
      this.kill();
    },

    hide : function(){
      this.$el.modal('hide');
    },
    
    show: function() {
      this.render().$el.modal('show');
      return this.deferred.promise();
    },
    
    resolveSelection: function(typeName, results){
      // calling resolveSelection with empty results is a failure
      if (!results || isEmpty(results)){
        this.deferred.reject();
      }
      this.deferred.resolve(typeName, results);
      this.hide();
    },
    
    uploadFileClicked: function({ accept, multiple, forceAssetType } = {}){
      this.uploader.triggerUploadWindow({ accept, multiple, forceAssetType });
      this.resolveSelection('upload', this.uploaderView);
    }
    
  });
  
export default AddMediaModal;
